<template>
    <component :is="resolvedLayout"></component>
</template>

<script>
import CustomerLayout from "@/views/layout/customer";
import GuestLayout from "@/views/layout/guest";
import InternalLayout from "@/views/layout/internal";
import {resolveStoreAccess} from "@/utils/access-context";

export default {
    name: "account-layout",
    components: {CustomerLayout, GuestLayout, InternalLayout},
    computed: {
        accessContext() {
            return resolveStoreAccess(this.$store);
        },
        resolvedLayout() {
            if (this.accessContext.template_family === 'customer') {
                return 'CustomerLayout';
            }

            if (this.accessContext.template_family === 'guest') {
                return 'GuestLayout';
            }

            return 'InternalLayout';
        },
    },
}
</script>
